module.exports = __webpack_public_path__ + "img/icon-basicEduS-11.8844c481.png";